import { ARTWORK_CONTINUATION_POLICIES } from "@/shared/constants/homeCarousel";

export const SUARTEWORLD_VIEW_SOURCE = Object.freeze({
  type: "suarteworld",
  label: "Suarteworld",
  continuation: ARTWORK_CONTINUATION_POLICIES.SUARTEWORLD,
});

export function createSuarteworldViewSource() {
  return { ...SUARTEWORLD_VIEW_SOURCE };
}

export function normalizeArtworkSource(source) {
  if (!source || typeof source !== "object") {
    return null;
  }

  const normalized = {
    type: source.type,
    label: typeof source.label === "string" ? source.label.trim() : "",
    continuation: source.continuation,
  };

  if (typeof normalized.continuation === "string") {
    normalized.continuation = normalized.continuation.trim();
  }

  if (!normalized.type && !normalized.label && !normalized.continuation) {
    return null;
  }

  return normalized;
}

export function inferArtworkSourceFromPathname(pathname) {
  if (typeof pathname !== "string") {
    return null;
  }

  if (pathname.includes("/suarteworld/")) {
    return createSuarteworldViewSource();
  }

  return null;
}

export function resolveArtworkViewSource({
  itemSource = null,
  navigationSource = null,
  pathname = null,
} = {}) {
  return (
    normalizeArtworkSource(itemSource)
    ?? normalizeArtworkSource(navigationSource)
    ?? inferArtworkSourceFromPathname(pathname)
    ?? null
  );
}

export function applySourceToArtworkList(items, source, overwrite = false) {
  if (!Array.isArray(items)) {
    return [];
  }

  const normalizedSource = normalizeArtworkSource(source);
  if (!normalizedSource) {
    return items;
  }

  return items.map((item) => {
    if (!item || typeof item !== "object") {
      return item;
    }

    const currentSource = item._artworkViewSource;
    const hasSource = Boolean(currentSource?.type || currentSource?.label);
    if (!overwrite && hasSource) {
      return item;
    }

    return {
      ...item,
      _artworkViewSource: normalizedSource,
    };
  });
}
